"use client";
import { jsx as d } from "react/jsx-runtime";
import { forwardRef as f, useContext as l } from "react";
import { Icon as u } from "../icon/icon.js";
import { ButtonRootContext as I } from "./context/button-root.context.js";
import { buttonIconRecipe as x } from "./styles/button-icon.styles.js";
const B = f(
  (o, t) => {
    const {
      tone: n = "brand",
      emphasis: s = "outlined",
      disabled: e = !1,
      onImpact: r = !1,
      size: a = "md",
      loading: m = !1
    } = l(I), { children: c, css: i, ...p } = o;
    return /* @__PURE__ */ d(
      u,
      {
        "data-c11n-component": "Button.Icon",
        "data-c11n-version": "10.0.0-alpha.19",
        ref: t,
        size: a === "sm" ? "sm" : "md",
        css: {
          ...x.raw({ tone: n, emphasis: s, disabled: e, onImpact: r, loading: m }),
          ...i
        },
        ...p,
        children: c
      }
    );
  }
);
B.displayName = "Button.Icon";
export {
  B as ButtonIcon
};
//# sourceMappingURL=button-icon.js.map
